/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum CcbSwitchName {
    ENABLE_DEBUG_SCREEN,
    ENABLE_DEVELOPER_SANDBOX,
    ENABLE_INCLUDE_ADULT,
    ENABLE_SUBSCRIBED_CHANNELS,
}
